<div class="row" style="padding: 9px;min-height: 405px;">

    <div class="body table-responsive">
        <table class="table table-stripped table-bordered table-hover">
            <thead>
                <tr>
                    <th colspan="12">
                        <div class="row mt-1" style="padding: 5px;">
                           

                             <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                                <label>Statut :
                                </label>
                                <ng-select name="statut_id"
                                    [(ngModel)]="itemToAdd.statut_id" placeholder="Choisissez "
                                    id="statut_id" [multiple]="false" [closeOnSelect]="true">
                                    <ng-option  [clearable]="false"
                                        *ngFor="let item of itemsStatut" [value]="item.id">{{
                                        item?.libelle }}
                                    </ng-option>
                                </ng-select>
                            </div>

                             <div
                                class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                                <label>Affection :
                                </label>
                                 <app-scroll-search-affection [clearText]="clearText"
                                         [emmitFull]="'true'"
                                        (onSelectAffection)="onSelectAffection($event)">
                                    </app-scroll-search-affection>
                            </div>

                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                                <label>Autorisation :
                                </label>
                                <ng-select name="autorisation"
                                    [(ngModel)]="itemToAdd.autorisation" placeholder="Choisissez "
                                    id="autorisation" [multiple]="false" [closeOnSelect]="true">
                                    <ng-option  [clearable]="false"
                                        *ngFor="let item of itemsAutorisation" [value]="item.code">{{
                                        item?.libelle }}
                                    </ng-option>
                                </ng-select>
                            </div>
                             <div
                                class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                                <label>Surprime :
                                </label>
                                 <input [disabled]="itemToAdd.autorisation!='is_pc'" type="text" mask="separator" class="form-control" [(ngModel)]="itemToAdd.surprime" name="surprime"/>
                            </div>
                            

                            <div class="col-md-1">
                                <br>
                                <button type="button" class="btn custom_btn_primary"
                                    (click)="addItemToList()">
                                     <!-- <i
                                        class="fa fa-fill">
                                    </i> -->
                                    Ajouter</button>
                            </div>

                        </div>
                    </th>
                </tr>
                <tr class="custom-table-head">
                    <th style="width: 5px;">
                        <a style="cursor: pointer" (click)="currentPage = 0; getItemsAffectionProduitBareme()"
                            title="Actualiser">
                            <i class="fa fa-redo-alt"></i></a>&nbsp;&nbsp; #
                    </th>
                    <th>Statut</th>
                    <th>Affection</th>
                    <th>Autorisation</th>
                    <th>Surprime</th>
                    <th>Option</th>
                </tr>
            </thead>
            <tbody>
                <tr style="cursor: pointer;"
                    *ngFor="let item of itemsAffectionProduitBareme; let indice = index"
                    (click)="currentRow = item">
                    <td class="txt-align-center">
                    </td>
                    <td>{{ item?.statut_libelle}}</td>
                    <td>{{ item?.affection_libelle}}</td>
                    <td>{{ item.is_pc?'Couvert':'Exclu'}}</td>
                    <td>{{ (item?.surprime | integerFormat) || 0}}</td>
                    <td>
                        <div class="custom-td-action">
                                   
                                    <a
                                      title="Supprimer"
                                      (click)="onDelete(indice)"
                                      class="custom-btn-delete"
                                    >
                                      <i class="fa fa-trash"></i
                                    ></a>
                                  </div>
                    </td>
                </tr>
            </tbody>

            <tfoot>
                <tr *ngIf="itemsAffectionProduitBareme && itemsAffectionProduitBareme.length > 0">
                    <td colspan="12">
                        <div class="row pagination-part">
                            <div class="col-md-9" style="text-align: center">
                                <pagination [ngModelOptions]="{standalone: true}"
                                    [maxSize]="5" [boundaryLinks]="true"
                                    [itemsPerPage]="itemsPerPage"
                                    [totalItems]="totalItems" [(ngModel)]="currentPage"
                                    class="pagination-sm" previousText="&lsaquo;"
                                    nextText="&rsaquo;" firstText="&laquo;"
                                    lastText="&raquo;"
                                    (pageChanged)="pageChanged($event)">
                                </pagination>
                            </div>

                            <div class="col-md-3">
                                <div class="paginator-per-page">
                                    <app-element-by-page-paginator (paginationChange)="
                changePaginationSize($event)
              " [defaultItemPerPage]="itemsPerPage">
                                    </app-element-by-page-paginator>

                                    <span class="span_total_entree pull-right">Total :
                                        {{ totalItems
                                        }}</span>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>

                <tr *ngIf="!itemsAffectionProduitBareme || itemsAffectionProduitBareme.length == 0">
                    <td colspan="12">
                        <div class="col-md-12 txt-align-center">
                            Aucune donnée disponible
                        </div>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</div>